import { Coords } from "google-map-react";

export const CHANGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE = 'CHANGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE';
export const RESTORE_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE = 'RESTORE_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE';
export const DEFAULT_LODGINGS_AND_RESERVATIONS_FILTER_STATE = 'DEFAULT_LODGINGS_AND_RESERVATIONS_FILTER_STATE';
export const NEXT_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE = 'NEXT_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE';


export type LodgingsAndReservationsFilterState = {
  coords?: Coords;
  miles: number;
  fromDate: Date;
  toDate?: Date;
  page: number;
  lodgingsWithRoomsOnly?: boolean;
}

interface ChangeLodgingsAndReservationsFiltersState extends LodgingsAndReservationsFilterState {
  type: typeof CHANGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE;
}

interface RestorePageLodgingsAndReservationsFiltersState extends LodgingsAndReservationsFilterState {
  type: typeof RESTORE_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE;
}

interface DefaultLodgingsAndReservationsFiltersState {
  type: typeof DEFAULT_LODGINGS_AND_RESERVATIONS_FILTER_STATE;
}

interface NextPageLodgingsAndReservationsFiltersState {
  type: typeof NEXT_PAGE_LODGINGS_AND_RESERVATIONS_FILTER_STATE;
}

export type LodgingsAndReservationsFilterActionTypes = ChangeLodgingsAndReservationsFiltersState | DefaultLodgingsAndReservationsFiltersState | NextPageLodgingsAndReservationsFiltersState | RestorePageLodgingsAndReservationsFiltersState;